<template>
  <div
    id="preenchimento-form-legalizacao"
    class="page-wrapper"
    :class="{ 'allow-force-validation': isForcedDirty, 'allow-force-validation-socio': isForcedDirtySocio }"
  >
    <TrfGlobalLoader v-if="isFormLoading" v-e2e="'template-loader'" type="fixed" />
    <div class="container is-flex is-flex-direction-column is-align-items-center">
      <template
        v-for="(campoEmpresa, index) in formData.camposEmpresa"
        :key="campoEmpresa.id ? campoEmpresa.id : campoEmpresa.uuid ? campoEmpresa.uuid : index"
      >
        <div class="box-campo is-relative" tabindex="-1">
          <TrfCampoPreenchivel
            :isPreenchimento="pIsPreenchimento"
            :pCampo="campoEmpresa"
            :pSocios="campoEmpresa.socios"
            :pEmpresa="modeloFormulario.empresa"
            :pHasAnexos="pProcessoHasAnexos"
            :pIsConferencia="pIsConferencia"
            :isForcedDirty="isForcedDirty"
            @elegalize-iniciar-formulario-socio="doAbrirModalCadastroSocio"
            @update:value="($event) => setCampoAlterado($event, campoEmpresa, index, FORM_CAMPO.EMPRESA)"
            @update:campo-padrao="($event) => setCampoPadrao($event, FORM_CAMPO.EMPRESA)"
            @set:validacao="($event) => setValidacao($event)"
            @edit:socio="doIniciarEdicaoSocio"
          ></TrfCampoPreenchivel>
        </div>
      </template>
    </div>
    <TrfSimpleModal
      v-if="modalVisualizarSocio.isActive"
      :titulo="pIsConferencia? 'Conferência de sócio' : 'Cadastro de Sócio'"
      :isAtivo="modalVisualizarSocio.isActive"
      @close="doFecharModalCadastroSocio"
    >
      <div class="is-flex is-flex-direction-column is-align-items-center">
        <template
          v-for="(camposSocio, index) in formData.camposSocio"
          :key="camposSocio.id ? camposSocio.id : camposSocio.uuid ? camposSocio.uuid : index"
        >
          <div class="box-campo-socio is-relative" tabindex="-1">
            <TrfCampoPreenchivel
              :isPreenchimento="pIsPreenchimento"
              :pCampo="camposSocio"
              :pEmpresa="modeloFormulario.empresa"
              :pSocioEmPreenchimento="socioEmPreenchimento"
              :pIsConferencia="pIsConferencia"
              @update:value="($event) => setCampoAlterado($event, camposSocio, index, FORM_CAMPO.SOCIO)"
              @update:campo-padrao="($event) => setCampoPadrao($event, FORM_CAMPO.SOCIO)"
              :isForcedDirty="isForcedDirtySocio"
              @set:validacao="($event) => setValidacaoSocio($event)"
            ></TrfCampoPreenchivel>
          </div>
        </template>
      </div>

      <template v-slot:slot-footer>
        <div>
          <button v-if="!pIsConferencia" :class="{ 'button is-primary': true }" @click="doAdicionarSocioPreenchido">Cadastrar</button>
          <button class="button" @click="doFecharModalCadastroSocio">{{ pIsConferencia? 'Voltar' : 'Cancelar'}}</button>
        </div>
      </template>
    </TrfSimpleModal>
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import { routerUtils } from '../../util/router.utils';
import Formulario from '../../model/formulario.model.js';
import DadosSocio from '../../views/Legalize/CadastroDeProcessos/Models/dados-socio.model.js';
import { ToastBuilder, toastTypeEnum } from '../../builder/toast.builder.js';

const SOCIO_VAZIO = {
  socio: {},
  camposPersonalizados: []
};

const socioIncompletoToast = new ToastBuilder();
socioIncompletoToast.setType(toastTypeEnum.DANGER);
socioIncompletoToast.setMessage('Campo(s) obrigatório(s) e/ou inválido(s)!');

export default {
  name: 'TrfPreenchimentoForm',
  emits: ['add:socio', 'update:form-data', 'update:campo-padrao', 'edit:socio'],
  components: {
    TrfGlobalLoader: defineAsyncComponent(() => import('../GlobalLoader/index.vue')),
    TrfCampoPreenchivel: defineAsyncComponent(() => import('../VisualizarForm/components/CampoPreenchivel.vue')),
    TrfSimpleModal: defineAsyncComponent(() => import('../Modal/TrfSimpleModal.vue'))
  },
  props: {
    pModeloFormulario: {
      type: Object,
      default: () => {}
    },
    pFormData: {
      type: Object,
      default: new Formulario()
    },
    pProcessoHasAnexos: {
      type: Boolean,
      default: false
    },
    pIsPreenchimento: {
      type: Boolean,
      default: true
    },
    pIsConferencia: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isFormLoading: false,
      estilosPadrao: '',
      formData: this.pFormData,
      socioEmPreenchimento: null,
      validacaoSocioEmPreenchimento: {},
      modeloFormulario: this.pModeloFormulario,
      modalVisualizarSocio: {
        isActive: false
      },
      FORM_CAMPO: {
        EMPRESA: 1,
        SOCIO: 2
      },
      isForcedDirty: false,
      isForcedDirtySocio: false,
      formValidacoes: {}
    };
  },
  computed: {
    isFormValido() {
      let status = true;
      for (const validacao in this.formValidacoes) {
        if (!this.formValidacoes[validacao]) {
          status = false;
          break;
        }
      }
      return status;
    },
    isSocioObrigatorio() {
      return this.formData.camposSocio.some(cs => cs.obrigatorio);
    },
    isSocioEmpreenchimentoValido() {
      if (!this.socioEmPreenchimento) return true;
      let status = true;
      for (const validacao in this.validacaoSocioEmPreenchimento) {
        if (!this.validacaoSocioEmPreenchimento[validacao]) {
          status = false;
          break;
        }
      }
      return status;
    }
  },
  watch: {
    pFormData: {
      immediate: true,
      handler(novo) {
        this.formData = novo;
      },
      deep: true
    }
  },
  methods: {
    doAbrirModalCadastroSocio() {
      this.isForcedDirtySocio = false;
      this.socioEmPreenchimento = { ...SOCIO_VAZIO };
      this.socioEmPreenchimento.socio = new DadosSocio();
      this.socioEmPreenchimento.camposPersonalizados = []
      this.validacaoSocioEmPreenchimento = {};
      this.modalVisualizarSocio.isActive = true;
    },
    doFecharModalCadastroSocio() {
      this.modalVisualizarSocio.isActive = false;
    },
    doIniciarEdicaoSocio(opcoesForm) {
      this.isForcedDirtySocio = false;
      const opcoes = opcoesForm.detail;
      this.socioEmPreenchimento = { ...SOCIO_VAZIO };
      this.socioEmPreenchimento.socio = opcoes.dadosEdicao? opcoes.dadosEdicao : opcoes.dadosVisualizacao;
      this.socioEmPreenchimento.camposPersonalizados = [];
      this.validacaoSocioEmPreenchimento = {};
      this.modalVisualizarSocio.isActive = true;
    },
    setValidacao(validacao) {
      const guid = `g${validacao.campo.uuid}`;
      this.formValidacoes[guid] = validacao.isValido;
    },
    setValidacaoSocio(validacao) {
      const guid = `g${validacao.campo.uuid}`;
      this.validacaoSocioEmPreenchimento[guid] = validacao.isValido;
    },
    async doValidar() {
      this.isForcedDirty = true;
      await this.$nextTick();
      return this.isFormValido;
    },
    async doValidarSocio() {
      this.isForcedDirtySocio = true;
      await this.$nextTick();
      return this.isSocioEmpreenchimentoValido;
    },
    async doAdicionarSocioPreenchido() {
      if (!this.socioEmPreenchimento) return;
      const isValido = await this.doValidarSocio();

      if (!isValido) {
        socioIncompletoToast.toast();
        return;
      }

      this.emitirSocioEmPreenchimento();
      this.doFecharModalCadastroSocio();
    },
    getRespostaSocioAtual(campo) {
      if (!campo.respostasSocios) return null;
      const socioResposta = campo.respostasSocios.find((resposta, index) => {
        return this.empresa.socios.some((socio) => {
          return socio.id == resposta.id || socio.uuid == resposta.uuid;
        });
      });
      return socioResposta;
    },
    doFechar() {
      routerUtils._carregarNovaRota('/formularios/');
    },
    setCampoAlterado(evento, campo, index, formCampo) {
      if (!evento) return;
      const campoAlterado = { ...campo, ...evento };
      if (formCampo === this.FORM_CAMPO.EMPRESA) {
        this.formData.camposEmpresa[index] = campoAlterado;
      } else {
        this.setSocioEmEdicao(campoAlterado, false, index);
        return;
      }
      this.$emit('update:form-data', this.formData);
    },
    setCampoPadrao(formData, formCampo) {
      if (formCampo === this.FORM_CAMPO.SOCIO) {
        this.setSocioEmEdicao(formData.respostaCampoPadrao, true);
        return;
      }
      this.$emit('update:campo-padrao', { formData: { ...formData.respostaCampoPadrao } });
    },
    setSocioEmEdicao(respostaCampo, isPadrao, indexPersonalizado) {
      if (!this.socioEmPreenchimento) return;
      if (isPadrao) {
        this.socioEmPreenchimento.socio = { ...this.socioEmPreenchimento.socio, ...respostaCampo };
      } else {
        this.socioEmPreenchimento.camposPersonalizados[indexPersonalizado] = respostaCampo;
        const respostaIndex = this.socioEmPreenchimento.camposPersonalizados[indexPersonalizado].respostasSocios.findIndex(resposta => {
          return respostaCampo.respostasSocios.some(respostaSocio => (resposta.id != null && resposta.id == respostaSocio.id) || resposta.uuid != null && resposta.uuid == respostaSocio.uuid)
        })
        if (respostaIndex != -1) {
          this.socioEmPreenchimento.camposPersonalizados[indexPersonalizado].respostasSocios[respostaIndex] = {
            ...this.socioEmPreenchimento.camposPersonalizados[indexPersonalizado].respostasSocios[respostaIndex],
            respostaTexto: respostaCampo.respostaTexto,
            respostaTextoHtml: respostaCampo.respostaTextoHtml,
            respostaOpcoes: respostaCampo.respostaOpcoes
          }
        } else {
          this.socioEmPreenchimento.camposPersonalizados[indexPersonalizado].respostasSocios.push(
            {
          processoSocioId: this.socioEmPreenchimento.socio.id,
          uuid: this.socioEmPreenchimento.socio.uuid,
          respostaTexto: respostaCampo.respostaTexto,
          respostaTextoHtml: respostaCampo.respostaTextoHtml,
          respostaOpcoes: respostaCampo.respostaOpcoes
        }
          )
        }
        this.socioEmPreenchimento.camposPersonalizados[indexPersonalizado].respostaTexto = null;
        this.socioEmPreenchimento.camposPersonalizados[indexPersonalizado].respostaTextoHtml = null;
        this.socioEmPreenchimento.camposPersonalizados[indexPersonalizado].respostaOpcoes = [];
      }
    },
    emitirCampoPadrao(formData) {
      this.$emit('update:form-data', formData);
    },
    emitirSocioEmPreenchimento(socio = this.socioEmPreenchimento) {
      this.$emit('add:socio', socio);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/sass/variables.scss';
.page-wrapper {
  width: 100%;
}
.container {
  box-sizing: border-box;
  padding-right: 4rem;
}
.box-campo {
  border-top: 0.75rem solid var(--primaryColor, #a82339);
  border-left: 1rem solid var(--primaryColor, #a82339);
  border-radius: 8px;
  padding: 2em;
  width: 100%;
  max-width: 744px;
  box-sizing: border-box;
  box-shadow: 2px 2px 2px #70757a66;
  transition: border 0.35s ease 0s;
  margin-bottom: 2.25rem;
}
.box-campo-socio {
  width: 100%;
  max-width: 744px;
  margin-bottom: 2.25rem;
}
.box-campo, .box-campo-socio {
  word-break: break-word;
  overflow-wrap: anywhere;
  white-space: normal;
}
</style>
<style lang="scss">
#preenchimento-form-legalizacao {
  &.allow-force-validation,
  &.allow-force-validation-socio {
    .box-campo {
      box-shadow: 2px 2px 2px rgba(169, 68, 66, 0.4) !important;
    }
  }
  .allow-markup-error {
    label:not(.checkbox):not(.radio),
    .titulo-campo-preenchivel,
    .titulo-campo-preenchivel strong,
    .titulo-campo-preenchivel span {
      color: #a94442 !important;
    }
    .multiselect,
    input[type='text'],
    input[type='number'],
    select,
    textarea,
    input[type='tel'],
    input[type='email'],
    input.input {
      border: 1px solid #a94442 !important;
    }
    .error-message {
      font-size: 12px !important;
      color: #a94442 !important;
    }
    .editor-wrapper.inline #trf-toolbar-text-editor .mce-content-body {
      border-bottom: 1px solid #a94442 !important;
    }
    .field.has-addons .control .button.is-static {
      border: 1px solid #a94442 !important;
      color: #a94442 !important;
    }
  }
}
</style>
